"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getResponsiveValue = void 0;

/**
 * A safe index access, where the step (index) is clamped to the
 * length of the values array. If step is less than 0, then it's clamped to 0.
 * If step is greater than or equal to values.length, then it's clamped to
 * values.length - 1. If values is an empty array, then the defaultValue is
 * returned.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getResponsiveValue = function getResponsiveValue(values, step, defaultValue) {
  var i = Math.max(0, Math.min(values.length - 1, step));
  return i >= values.length ? defaultValue : values[Math.min(values.length - 1, step)];
};

exports.getResponsiveValue = getResponsiveValue;